import $ from 'jquery';

const footerGrid = () => {
    // Target the specific footer grid container or the Elementor menu wrapper
    const el = {
        parent: $('.footer-grid, .mi-footer--menu'),
    }

    if (!el.parent.length) return;

    el.parent.each(function () {
        const $parent = $(this);
        const $navMain = $parent.find('.elementor-nav-menu--main');
        const $ul = $navMain.find('> ul.elementor-nav-menu');

        // Prevent double execution
        if (!$ul.length || $parent.find('.footer-bento-wrapper').length) return;

        const $items = $ul.children('li');

        // Get original classes to preserve Elementor styling (like sm-vertical)
        const ulClass = $ul.attr('class') || 'elementor-nav-menu';

        // Group items into 3 separate lists for the bento layout
        const $col1 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-1"></ul>`).append($items.slice(0, 4));
        const $col2 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-2"></ul>`).append($items.slice(4, 7));
        const $col3 = $(`<ul class="${ulClass} footer-bento-col footer-bento-col-3"></ul>`).append($items.slice(7));

        // Create a wrapper div to contain the 3 columns
        // Left without inline grid/flex styles so you have full freedom to style it in your CSS
        const $wrapper = $('<div class="footer-bento-wrapper"></div>');
        $wrapper.append($col1, $col2, $col3);

        // Replace the original single UL with the new multi-column bento wrapper
        $ul.replaceWith($wrapper);
    });
}

try {
    footerGrid();
} catch (error) {
    console.error('Error in footerGrid:', error);
}